import React, { useState } from "react";
import { GiphyFetch } from "@giphy/js-fetch-api";
import { Gif,Grid } from "@giphy/react-components";


const giphyFetch = new GiphyFetch("7tp81pCC72Tmsxd1nLh9gFtaFDHJkzEU");


const GridDemo = ({ onGifClick }) => {
  const fetchGifs = (offset) =>
    giphyFetch.trending({ offset, limit: 10 });
  return (
    <Grid
      onGifClick={onGifClick}
      fetchGifs={fetchGifs}
      width={800}
      columns={3}
      gutter={6}
    />
  );
}

const Giffy = () => {
  const [modalGif, setModalGif] = useState();
  return (
    <div className="giffy_content">
      
      <GridDemo
        onGifClick={(gif, e) => {
          console.log("gif", gif);
          e.preventDefault();
          setModalGif(gif);
        }}
      />
     {modalGif && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(0, 0, 0, .8)"
          }}
          onClick={e => {
            e.preventDefault();
            setModalGif(undefined);
          }}
        >
          <Gif gif={modalGif} width={200} />
        </div>
      )}
    </div>
  );
}
export default (Giffy);